import React from 'react';
import styled from 'styled-components';

import { smallMediaQuery } from '../../../../../common/utilities/sizeHelpers';
import { AnimatedLoadingPlaceholder } from '../../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';

export const ForecastIconLoadingUI = () => {
    return (
        <Container>
            <AnimatedLoadingPlaceholder width={50} height='50px' radius={50}/>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 59px;
    height: 59px;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    @media ${smallMediaQuery} {
        width: 50px;
        height: 50px;
    }
`;